import { render, staticRenderFns } from "./index.vue?vue&type=template&id=82202e20&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=82202e20&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=82202e20&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82202e20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82202e20')) {
      api.createRecord('82202e20', component.options)
    } else {
      api.reload('82202e20', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=82202e20&scoped=true", function () {
      api.rerender('82202e20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/batchUnlockTip/index.vue"
export default component.exports